import React from "react"
import ReactDOM from "react-dom/client"

import { LocaleProvider } from "@app/scripts/react-providers/locales"
import { ProductStl } from "@app/scripts/react-product-stl/components/ProductStl"

import type { Product } from "@app/scripts/types"

const ProductStlElem = class extends HTMLElement {
  static observedAttributes = ["header-image", "btn-style"]

  connectedCallback() {
    const headerImage = this.getAttribute("header-image")
    const btnStyle = this.getAttribute("btn-style") || "default"
    const btnColor = this.getAttribute("btn-color") || "white"
    const products: Product[] = [];
    const productAttributes = ["product_1", "product_2", "product_3", "product_4"]

    for (const attribute of productAttributes) {
      const product = this.getAttribute(attribute)
      try {
        const productObj = JSON.parse(product || "{}")
        if (productObj?.id) {
          products.push(productObj)
        }
      } catch (error) {
        console.warn(`Failed to parse ${attribute}:`, error)
      }
    }

    const root = ReactDOM.createRoot(this)
    root.render(
      <LocaleProvider>
        <ProductStl
          products={products}
          headerImage={headerImage}
          btnStyle={btnStyle}
          btnColor={btnColor}
        />
      </LocaleProvider>
    )
  }
}

customElements.define("product-stl", ProductStlElem)
